/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import Helper from "../utils/Helper";
import _ from "underscore";

export const getUserOrderCreatePaymentStatus = state =>
  state &&
  state.order &&
  state.order.createPayment &&
  state.order.createPayment.status
    ? state.order.createPayment.status
    : false;
export const getUserOrderCreatePaymentData = state =>
  state &&
  state.order &&
  state.order.createPayment &&
  state.order.createPayment.item
    ? state.order.createPayment.item
    : false;

// user object from /me
export const getUserName = state => (state && state.name ? state.name : "");
export const getUserPointBalance = state =>
  state && state.point && state.point.balance ? state.point.balance : 0;
export const getUserQrString = state =>
  state && state.qr && state.qr.value ? state.qr.value : null;
export const getUserQrImage = state =>
  state && state.qr && state.qr.image && state.qr.image.src
    ? state.qr.image.src
    : null;

// user cart
export const getUserCartLoading = state =>
  state && state.cartLoading ? state.cartLoading : false;
export const getUserCartItem = state =>
  state && state.cart && state.cart.item ? state.cart.item : null;
export const getDeleteUserCartLoading = state =>
  state && state.deleteCart && state.deleteCart.loading
    ? state.deleteCart.loading
    : false;
export const getDeleteUserCartStatus = state =>
  state && state.deleteCart && state.deleteCart.status
    ? state.deleteCart.status
    : false;
export const getApplyUserCartWalletLoading = state =>
  state && state.apply && state.apply.wallet && state.apply.wallet.loading
    ? state.apply.wallet.loading
    : false;
export const getApplyUserCartWalletStatus = state =>
  state && state.apply && state.apply.wallet && state.apply.wallet.status
    ? state.apply.wallet.status
    : false;
export const getApplyUserCartPointLoading = state =>
  state && state.apply && state.apply.point && state.apply.point.loading
    ? state.apply.point.loading
    : false;
export const getApplyUserCartPointStatus = state =>
  state && state.apply && state.apply.point && state.apply.point.status
    ? state.apply.point.status
    : false;
export const getRequestCartFoodLoading = state =>
  state &&
  state.requestCart &&
  state.requestCart.add &&
  state.requestCart.add.loading
    ? state.requestCart.add.loading
    : false;
export const getUpdateCartFoodLoading = state =>
  state &&
  state.requestCart &&
  state.requestCart.edit &&
  state.requestCart.edit.loading
    ? state.requestCart.edit.loading
    : false;
export const getRequestCartFoodStatus = state =>
  state &&
  state.requestCart &&
  state.requestCart.add &&
  state.requestCart.add.status
    ? state.requestCart.add.status
    : false;
export const getUpdateCartFoodStatus = state =>
  state &&
  state.requestCart &&
  state.requestCart.edit &&
  state.requestCart.edit.status
    ? state.requestCart.edit.status
    : false;
export const getUserOrderDetailItem = state =>
  state &&
  state.order &&
  state.order.orderDetail &&
  state.order.orderDetail.item
    ? state.order.orderDetail.item
    : null;
export const getUserOrderDetailLoading = state =>
  state &&
  state.order &&
  state.order.orderDetail &&
  state.order.orderDetail.loading
    ? state.order.orderDetail.loading
    : false;
export const getUserCheckoutStatus = state =>
  state && state.checkout && state.checkout.status
    ? state.checkout.status
    : false;
export const getUserCheckoutLoading = state =>
  state && state.checkout && state.checkout.loading
    ? state.checkout.loading
    : false;
export const getUserCheckoutItem = state =>
  state && state.checkout && state.checkout.item ? state.checkout.item : null;
export const getIsUserCartItemEmpty = state =>
  _.isEmpty(getUserCartItem(state));
export const getUserCartItemLength = state => {
  const cartStalls = getUserCartItemStall(getUserCartItem(state));

  let totalNumberItems = 0;

  if (_.isEmpty(cartStalls)) {
    return 0;
  }

  for (let i = 0; i < cartStalls.length; i++) {
    const stallItems = getUserCartItemStallItems(cartStalls[i]);

    for (let k = 0; k < stallItems.length; k++) {
      totalNumberItems = totalNumberItems + stallItems[k].quantity;
    }
  }

  return totalNumberItems;
};
export const getUpdateUserCartTableLoading = state =>
  state && state.table && state.table.loading ? state.table.loading : false;
export const getUserOrderListItems = state =>
  state && state.order && state.order.list && state.order.list.items
    ? state.order.list.items
    : [];
export const getUserOrderListPagination = state =>
  state && state.order && state.order.list && state.order.list.pagination
    ? state.order.list.pagination
    : null;
export const getUserOrderListLoading = state =>
  state && state.order && state.order.list && state.order.list.loading
    ? state.order.list.loading
    : false;
export const getUserOrderListHideLoading = state =>
  state && state.order && state.order.list && state.order.list.hideLoading
    ? state.order.list.hideLoading
    : false;
export const getCancelOrderLoading = state =>
  state && state.order && state.order.cancel && state.order.cancel.loading
    ? state.order.cancel.loading
    : false;
export const getCancelOrderStatus = state =>
  state && state.order && state.order.cancel && state.order.cancel.status
    ? state.order.cancel.status
    : false;
export const getUserOrderUpdatePaymentLoading = state =>
  state && state.order && state.order.updatePaymentLoading
    ? state.order.updatePaymentLoading
    : false;
export const getOrderIndicatorStatus = state =>
  state && state.order && state.order.indicator ? state.order.indicator : false;
export const getQueueInProgressItem = state =>
  state &&
  state.queue &&
  state.queue.progress &&
  state.queue.progress.item &&
  state.queue.progress.item.stall
    ? state.queue.progress.item.stall
    : null;
export const getQueueInProgressLoading = state =>
  state && state.queue && state.queue.progress && state.queue.progress.loading
    ? state.queue.progress.loading
    : false;
export const getQueueReadyItem = state =>
  state &&
  state.queue &&
  state.queue.ready &&
  state.queue.ready.item &&
  state.queue.ready.item.stall
    ? state.queue.ready.item.stall
    : null;
export const getQueueReadyLoading = state =>
  state && state.queue && state.queue.ready && state.queue.ready.loading
    ? state.queue.ready.loading
    : false;
export const getQueueCompleteItem = state =>
  state &&
  state.queue &&
  state.queue.complete &&
  state.queue.complete.item &&
  state.queue.complete.item.stall
    ? state.queue.complete.item.stall
    : null;
export const getQueueCompleteLoading = state =>
  state && state.queue && state.queue.complete && state.queue.complete.loading
    ? state.queue.complete.loading
    : false;
export const getIsFoodOnlyStatus = state =>
  state &&
  state.cart &&
  state.cart.item &&
  state.cart.item.attribute &&
  state.cart.item.attribute.is_food_only
    ? state.cart.item.attribute.is_food_only
    : false;

// cart
export const getUserCartItemStall = cart =>
  cart && cart.stall && cart.stall.items ? cart.stall.items : [];
export const getUserCartItemCurrencySymbol = cart =>
  cart && cart.currency && cart.currency.symbol ? cart.currency.symbol : "";
export const getUserCartItemID = cart => (cart && cart.id ? cart.id : null);
export const getUserCartItemStatusName = cart =>
  cart && cart.status && cart.status.name ? cart.status.name : null;
export const getUserCartItemNumber = cart =>
  cart && cart.number ? cart.number : null;
export const getUserCartItemTableCode = cart =>
  cart && cart.table && cart.table.code ? cart.table.code : "";
export const getUserCartItemCheckoutSummaryItem = cart =>
  cart && cart.checkout && cart.checkout.summary && cart.checkout.summary.items
    ? cart.checkout.summary.items
    : null;
export const getUserCartItemCheckoutWallet = cart =>
  cart && cart.checkout && cart.checkout.wallet ? cart.checkout.wallet : null;
export const getUserCartItemCheckoutPoint = cart =>
  cart && cart.checkout && cart.checkout.point ? cart.checkout.point : null;
export const getUserCartItemCheckoutPayment = cart =>
  cart && cart.checkout && cart.checkout.payment ? cart.checkout.payment : null;
export const getUserCartItemIsTableRequired = cart =>
  cart && cart.attribute && cart.attribute.is_table_required
    ? cart.attribute.is_table_required
    : false;
export const getUserCartItemToken = cart =>
  cart && cart.token ? cart.token : null;
export const getUserCartItemQuantityTotal = cart =>
  cart && cart.total && cart.total.quantity ? cart.total.quantity : 0;
export const getUserCartWalletBalance = cart =>
  cart && cart.checkout && cart.checkout.wallet && cart.checkout.wallet.balance
    ? cart.checkout.wallet.balance
    : null;
export const getUserCartPointBalance = cart =>
  cart && cart.checkout && cart.checkout.point && cart.checkout.point.balance
    ? cart.checkout.point.balance
    : null;
export const getUserCartPaymentBalance = cart =>
  cart &&
  cart.checkout &&
  cart.checkout.payment &&
  cart.checkout.payment.balance
    ? cart.checkout.payment.balance
    : 0;
export const getUserCartWalletIsApplied = cart =>
  cart &&
  cart.checkout &&
  cart.checkout.wallet &&
  cart.checkout.wallet.attribute &&
  cart.checkout.wallet.attribute.is_applied
    ? cart.checkout.wallet.attribute.is_applied
    : false;
export const getUserCartPointIsApplied = cart =>
  cart &&
  cart.checkout &&
  cart.checkout.point &&
  cart.checkout.point.attribute &&
  cart.checkout.point.attribute.is_applied
    ? cart.checkout.point.attribute.is_applied
    : false;
export const getErrorType = state =>
  state && state.cart && state.cart.error ? state.cart.error : false;

// stall
export const getUserCartItemStallID = stall =>
  stall && stall.id ? stall.id : null;
export const getUserCartItemStallName = stall =>
  stall && stall.name ? stall.name : null;
export const getUserCartItemStallItems = stall =>
  stall && stall.items ? stall.items : [];
export const getUserCartItemStallTotalQuantity = stall =>
  stall && stall.total && stall.total.quantity ? stall.total.quantity : null;
export const getUserCartItemStallTotalPrice = stall =>
  stall && stall.total && stall.total.price
    ? Helper.formatPriceNumber(stall.total.price)
    : Helper.formatPriceNumber(0);
export const getUserCartItemStallTotalTax = stall =>
  stall && stall.total && stall.total.tax ? stall.total.tax : null;
export const getUserCartItemStallTotalDelivery = stall =>
  stall && stall.total && stall.total.delivery ? stall.total.delivery : null;
export const getUserCartItemStallTotalPoint = stall =>
  stall && stall.total && stall.total.point ? stall.total.point : null;
export const getUserCartItemStallTotalDiscount = stall =>
  stall && stall.total && stall.total.discount ? stall.total.discount : null;
export const getUserCartItemStallTotalFinal = stall =>
  stall && stall.total && stall.total.final ? stall.total.final : null;
export const getUserCartItemStallCurrency = stall =>
  stall && stall.currency && stall.currency.symbol ? stall.currency.symbol : "";

// stallItem
export const getUserCartItemStallItem = (state, cartItemId) => {
  const cartStalls = getUserCartItemStall(getUserCartItem(state));

  if (_.isEmpty(cartStalls)) {
    return null;
  }

  for (let i = 0; i < cartStalls.length; i++) {
    const stallItems = getUserCartItemStallItems(cartStalls[i]);

    for (let k = 0; k < stallItems.length; k++) {
      const stallItemId = getUserCartItemStallItemID(stallItems[k]);

      if (parseInt(stallItemId) === parseInt(cartItemId)) {
        return stallItems[k];
      }
    }
  }

  return null;
};
export const getUserCartItemStallItemID = stallItem =>
  stallItem && stallItem.id ? stallItem.id : null;
export const getUserCartItemStallItemStatusCode = stallItem =>
  stallItem && stallItem.status && stallItem.status.code
    ? stallItem.status.code
    : null;
export const getUserCartItemStallItemQuantity = stallItem =>
  stallItem && stallItem.quantity ? stallItem.quantity : null;
export const getUserCartItemStallItemTitle = stallItem =>
  stallItem && stallItem.title ? stallItem.title : null;
export const getUserCartItemStallItemDescription = stallItem =>
  stallItem && stallItem.description ? stallItem.description : null;
export const getUserCartItemStallItemImageLargeSrc = stallItem =>
  stallItem &&
  stallItem.image &&
  stallItem.image.large &&
  stallItem.image.large.src
    ? stallItem.image.large.src
    : null;
export const getUserCartItemStallItemImageSmallSrc = stallItem =>
  stallItem &&
  stallItem.image &&
  stallItem.image.small &&
  stallItem.image.small.src
    ? stallItem.image.small.src
    : null;
export const getUserCartItemStallItemAddOns = stallItem =>
  stallItem && stallItem.addons ? stallItem.addons : [];
export const getUserCartItemStallItemVariants = stallItem =>
  stallItem && stallItem.variants ? stallItem.variants : [];
export const getUserCartItemStallItemIsDelivery = stallItem =>
  stallItem && stallItem.attribute && stallItem.attribute.is_delivery
    ? stallItem.attribute.is_delivery
    : false;
export const getUserCartItemStallItemIsTakeAway = stallItem =>
  stallItem && stallItem.attribute && stallItem.attribute.is_take_away
    ? stallItem.attribute.is_take_away
    : false;
export const getUserCartItemStallItemIsAllowTakeAway = stallItem =>
  stallItem && stallItem.attribute && stallItem.attribute.is_allow_take_away
    ? stallItem.attribute.is_allow_take_away
    : false;
export const getUserCartItemStallItemTakeAwayText = stallItem =>
  stallItem && stallItem.take_away && stallItem.take_away.text
    ? stallItem.take_away.text
    : "";
export const getUserCartItemStallItemIsAllowDelivery = stallItem =>
  stallItem && stallItem.attribute && stallItem.attribute.is_allow_delivery
    ? stallItem.attribute.is_allow_delivery
    : false;
export const getUserCartItemStallItemTotalDelivery = stallItem =>
  stallItem && stallItem.total && stallItem.total.delivery
    ? Helper.formatPriceNumber(stallItem.total.delivery)
    : Helper.formatPriceNumber(0);
export const getUserCartItemStallItemIsCheckoutable = stallItem =>
  stallItem && stallItem.attribute && stallItem.attribute.is_checkoutable
    ? stallItem.attribute.is_checkoutable
    : false;
export const getUserCartItemStallItemTotalPrice = stallItem =>
  stallItem && stallItem.total && stallItem.total.price
    ? Helper.formatPriceNumber(stallItem.total.price)
    : Helper.formatPriceNumber(0);
export const getUserCartItemStallItemCurrencySymbol = stallItem =>
  stallItem && stallItem.currency && stallItem.currency.symbol
    ? stallItem.currency.symbol
    : "";
export const getUserCartItemStallItemRemark = stallItem =>
  stallItem && stallItem.remark ? stallItem.remark : null;
export const getUserCartItemStallItemTotalPriceWithCurrency = stallItem =>
  stallItem
    ? `${getUserCartItemStallItemCurrencySymbol(
        stallItem
      )} ${getUserCartItemStallItemTotalPrice(stallItem)}`
    : "";
export const getUserCartItemStallItemTotalDeliveryWithCurrency = stallItem =>
  stallItem
    ? `${getUserCartItemStallItemCurrencySymbol(
        stallItem
      )} ${getUserCartItemStallItemTotalDelivery(stallItem)}`
    : "";
export const getUserCartItemDiscount = stallItem =>
  stallItem && stallItem.total && stallItem.total.discount
    ? Helper.formatPriceNumber(stallItem.total.discount)
    : false;

// order summary
export const getOrderSummaryTableStatus = state =>
  state &&
  state.order &&
  state.order.orderDetail &&
  state.order.orderDetail.changeTableModal
    ? state.order.orderDetail.changeTableModal
    : "";
export const getOrderSummaryQrCode = state =>
  state &&
  state.location &&
  state.location.state &&
  state.location.state.qrcodeValue
    ? state.location.state.qrcodeValue
    : null;

// order
export const getUserOrderIsTableUpdatable = state =>
  state &&
  state.order &&
  state.order.orderDetail &&
  state.order.orderDetail.item &&
  state.order.orderDetail.item.attribute &&
  state.order.orderDetail.item.attribute.is_table_updatable
    ? state.order.orderDetail.item.attribute.is_table_updatable
    : false;



// WEBPACK FOOTER //
// ./src/selectors/user.js